const homePageWatcher = (route) => {
  console.log('route', route)
  if (route === '/') {
    return true
  }
  return false
}

export {
  homePageWatcher
}